import React from "react";
import { Card, CardContent, Typography, Grid } from "@mui/material";
import colors from "../../../../../../Constants/colors";

const SummaryCards = ({
  totalCharges,
  paymentStatus,
  latestInvocation,
  remainingCredits,
}) => {
  const formatTotalCharges = (totalCharges) => {
    return Number(totalCharges).toPrecision(4);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <Card
          sx={{
            bgcolor: colors.secondaryBlue,
            color: colors.extremeWhite,
            height: "120px",
          }}
        >
          <CardContent>
            <Typography variant="h6">Total Charges</Typography>
            <Typography variant="body2">
              ${formatTotalCharges(totalCharges)}
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={4}>
        <Card
          sx={{
            bgcolor: colors.secondaryBlue,
            color: colors.extremeWhite,
            height: "120px",
          }}
        >
          <CardContent>
            <Typography variant="h6">Credits</Typography>
            <Typography variant="body2">
              Used credits: ${parseFloat(totalCharges).toFixed(2)}
            </Typography>
            <Typography variant="body2">
              Remaining credits: ${parseFloat(remainingCredits).toFixed(2)}
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      {latestInvocation && (
        <Grid item xs={12} sm={4}>
          <Card
            sx={{
              bgcolor: colors.secondaryBlue,
              color: colors.extremeWhite,
              height: "120px",
            }}
          >
            <CardContent>
              <Typography variant="h6">Latest Invocation</Typography>
              <Typography variant="body2">
                {new Date(latestInvocation).toLocaleDateString()}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      )}
    </Grid>
  );
};

export default SummaryCards;
